'use strict';

let routes = function ($stateProvider, baseState) {

    $stateProvider

        .state('' + baseState + '', {
            abstract: true,
            url: "/just-browsing",
            views: {
                '': {
                    template: "<ui-view/>",
                },
                'sidebar@root': {
                    template: '<nav class="navbar-default navbar-static-side" role="navigation"><section-missions-just-browsing-side-menu></section-missions-just-browsing-side-menu></nav>'
                }
            },
            data: {
                workflowBaseState: baseState,
                showSideMenu: true
            }
        })

        .state('' + baseState + '.overview', {
            url: "/overview",
            template: require("./overview.html"),
            data: {pageTitle: 'Import'}
        })

        .state('' + baseState + '.ledgers-overview', {
            url: "/ledgers",
            template: require("../ledgers-overview.html"),
            data: {pageTitle: 'Import'}
        });

    let gaiSubsection = require('subsections/grant-and-import/grant-and-import.routing');
    gaiSubsection.routes($stateProvider, '' + baseState + '');

    $stateProvider

        .state('' + baseState + '.inspect', {
            abstract: true,
            url: "/organize",
            template: "<ui-view/>",
        })

        .state('' + baseState + '.inspect.overview', {
            url: "/overview",
            template: require("../inspect.overview.html"),
            data: {pageTitle: 'Inspect'}
        })

        .state('' + baseState + '.inspect.calendar', {
            abstract: true,
            url: "/calendar",
            template: require("../inspect.calendar.html"),
        })

        .state('' + baseState + '.inspect.calendar.overview', {
            url: "/overview",
            template: require("../inspect.calendar.overview.html"),
            data: {pageTitle: 'Inspect'}
        });

    let ilSubsection = require('subsections/inspect-ledger-contents/inspect-ledger-contents.routing');
    ilSubsection.loadRoutesLazily($stateProvider, '' + baseState + '');

    let mmSubsection = require('subsections/money-movements/money-movements');
    mmSubsection.loadRoutesLazily($stateProvider, '' + baseState + '');

    let beSubsection = require('subsections/business-events/business-events');
    beSubsection.loadRoutesLazily($stateProvider, '' + baseState + '');

    let wSubsection = require('subsections/whereabouts/whereabouts');
    wSubsection.loadRoutesLazily($stateProvider, '' + baseState + '');

    let sdSubsection = require('subsections/supporting-documents/supporting-documents');
    sdSubsection.loadRoutesLazily($stateProvider, '' + baseState + '');

    $stateProvider
    

        .state('' + baseState + '.game-plan', {
            url: "/game-plan",
            template: require("../missions.game-plan.html"),
        })

        .state('' + baseState + '.game-plan.modal-route-tree', {
            url: "/modal",
            resolve: {
                setRouteBasedContentFiltersLevel1: /*@ngInject*/ function (setRouteBasedContentFiltersLevel1A, routeBasedContentFilters, $stateParams) {
                },
            },
            onEnter: /*@ngInject*/ function ($state, GloballyAccessibleModalsService, $interval) {

                let showModal = function (modalElement) {

                    let stop = $interval(function () {
                        console.log('interval modal', modalElement, modalElement.hasClass('in'));
                        if (modalElement.hasClass('in')) {
                            $interval.cancel(stop);
                        } else {
                            // Prevent event conflict - https://github.com/handsontable/handsontable/issues/937
                            modalElement.on('shown.bs.modal', function() {
                                $(document).off('focusin.bs.modal');
                            });
                            // Show modal
                            modalElement.modal('show');
                        }
                    }, 1000);

                };

                let makeSureToLeaveModalRouteTreeOnModalClose = function (modalElement) {
                    if (!modalElement.modalRouteTreeEventsHookedUp) {
                        modalElement.on('hide.bs.modal', function () {
                            console.log('hide.bs.modal');
                            $state.go('' + baseState + '.game-plan', {activeClerkLedgerDeliverableId: null});
                        });
                        modalElement.modalRouteTreeEventsHookedUp = true;
                    }
                };

                // Wait until the modal-route-tree modal element is available
                GloballyAccessibleModalsService.deferredModalElementById('missions-game-plan-modal-route-tree').promise.then(
                    function (modalElement) {
                        console.log('show modal');
                        showModal(modalElement);
                        makeSureToLeaveModalRouteTreeOnModalClose(modalElement);
                    }
                );

            },
            onExit: /*@ngInject*/ function (GloballyAccessibleModalsService) {

                let closeModal = function (modalElement) {
                    modalElement.modal('hide');
                };

                // Wait until the modal-route-tree modal element is available
                GloballyAccessibleModalsService.deferredModalElementById('missions-game-plan-modal-route-tree').promise.then(
                    function (modalElement) {
                        console.log('close modal');
                        //closeModal(modalElement);
                    }
                );

            },
        });

    let clerkLedgerDeliverablesSubsection = require('crud/clerk-ledger-deliverable/routes').default;
    clerkLedgerDeliverablesSubsection.routes($stateProvider, '' + baseState + '.game-plan.modal-route-tree');

    // Custom view for guided quick editing
    $stateProvider
        .state('' + baseState + '.game-plan.modal-route-tree.clerk-ledger-deliverables.existing.edit.guided', {
            url: "/guided",
            resolve: {
                setRouteBasedContentFiltersLevel2: /*@ngInject*/ function (setRouteBasedContentFiltersLevel1, routeBasedContentFilters, $stateParams) {
                    routeBasedContentFilters.ClerkFiscalYear_ClerkTaxEntity_knowledge_of_internals_expected = '1';
                    routeBasedContentFilters.ClerkLedger_ClerkTaxEntity_knowledge_of_internals_expected = '1';
                    routeBasedContentFilters.ClerkTaxEntity_knowledge_of_internals_expected = '1';
                    routeBasedContentFilters.ClerkSignificantPeriod_RelevantClerkFiscalYear_ClerkTaxEntity_ClerkTaxEntityType_knowledge_of_internals_expected = '1';
                    routeBasedContentFilters.ClerkFiscalYear_ClerkTaxEntity_ClerkTaxEntityType_ref = '<>person';
                    routeBasedContentFilters.ClerkLedger_ClerkTaxEntity_ClerkTaxEntityType_ref = '<>person';
                    routeBasedContentFilters.ClerkTaxEntity_ClerkTaxEntityType_ref = '<>person';
                    routeBasedContentFilters.ClerkSignificantPeriod_RelevantClerkFiscalYear_ClerkTaxEntity_ClerkTaxEntityType_ref = '<>person';
                },
            },
            template: require("crud/clerk-ledger-deliverable/steps/guided.html"),
            data: {
                pageTitle: 'Edit Ledger Deliverable',
                showSideMenu: true
            }
        });
    
};

let loadRoutesLazily = function ($stateProvider, baseState) {

    let lazyStateProvider = {
        states: [],
        state: function (name, stateConfig) {
            let state = angular.merge({name: name}, stateConfig);
            this.states.push(state);
            return this;
        }
    };
    routes(lazyStateProvider, baseState);
    $stateProvider.state(baseState + '.**', {
        url: "/just-browsing",
        lazyLoad: function ($transition$, ParentService) {
            return lazyStateProvider;
        },
    });

};

export default {
    routes: routes,
    loadRoutesLazily: loadRoutesLazily,
};



// WEBPACK FOOTER //
// .-dna/app/sections/7-missions/just-browsing/routes.js